module.exports = __webpack_public_path__ + "img/header-background.4debe4a0.png";